import React from 'react';
import Switch from 'react-switch';

const SwitchButton = ({
	onChange,
	classNames,
	isChecked,
	SwitchLabel,
	rootClassNames,
}) => {
	const handleChange = (nextChecked) => {
		onChange(nextChecked);
	};

	return (
		<div className={rootClassNames}>
			<label htmlFor='react-switch' className='d-flex gap-10'>
				<span><SwitchLabel /></span>
				<Switch
					onChange={handleChange}
					checked={isChecked}
					className={classNames ? classNames : ''}
					onColor='#2a70ff'
					offColor='#F2F4F7'
					onHandleColor='#fff'
					handleDiameter={25}
					uncheckedIcon={false}
					checkedIcon={false}
					id='react-switch'
					boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
					activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
					borderRadius={50}
				/>
			</label>
		</div>
	);
};

export default SwitchButton;
